
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34254',
  depVersions: {
  "documents-public-ui": "static-1.34254",
  "client-types": "static-1.457",
  "documents-lib": "static-1.34259",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2030",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5495",
  "hs-test-utils": "static-1.7912",
  "hub-http": "static-1.6120",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11355",
  "I18n": "static-7.1603",
  "jasmine-immutable": "static-1.2918",
  "jasmine-runner": "static-1.6369",
  "lodash": "static-1.3",
  "quartz": "static-1.6870",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16557",
  "reporting-data": "static-1.67033",
  "reporting-testing-lib": "static-1.8966",
  "reporting-visualizations": "static-1.59109",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4670",
  "webpack-env": "static-1.54",
  "atom": "static-1.4972",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2395",
  "classnames": "static-2.10",
  "cssUtils": "static-1.770",
  "customer-data-filters-ui": "static-1.39365",
  "customer-data-objects": "static-1.7560",
  "customer-data-property-utils": "static-1.7985",
  "data-fetching-client": "static-1.9576",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4430",
  "flux-actions": "static-1.325",
  "FormsCommonComponents": "static-1.85581",
  "FormUrlGenerator": "static-2.4620",
  "foundations-components": "static-1.7725",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11663",
  "icons": "static-2.639",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7060",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3753",
  "property-translator": "static-1.5308",
  "quartz-config": "static-1.648",
  "quartz-core": "static-1.6089",
  "quick-fetch": "static-1.3836",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5268",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8068",
  "reference-resolvers-lite": "static-1.7990",
  "report-customization-components": "static-1.12840",
  "reporting-enablement": "static-1.22513",
  "reporting-reports": "static-1.66711",
  "reporting-snowflake": "static-1.55651",
  "reporting-ui-components": "static-2.64304",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4545",
  "sales-content-partitioning": "static-1.8838",
  "SalesContentIndexUI": "static-3.9090",
  "sanitize": "static-1.4374",
  "sanitize-text": "static-1.8046",
  "self-service-api": "static-1.10146",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1651",
  "signup-constants": "static-1.18662",
  "signup-ui-lego-core": "static-1.20672",
  "signup-ui-url-generator": "static-2.7941",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4670",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10892",
  "ui-addon-i18n": "static-1.11048",
  "ui-addon-react-router-dom": "static-1.9445",
  "ui-addon-upgrades": "static-9.17844",
  "ui-asset-management-lib": "static-1.10884",
  "ui-images": "static-2.1130",
  "UIComponents": "static-3.8302",
  "usage-tracker": "static-1.7236",
  "usage-tracker-container": "static-1.7226",
  "usage-tracker-core": "static-1.7086",
  "usage-tracker-public": "static-1.7047",
  "viral-links-lib": "static-1.6943",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3325",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3147",
  "quartz-webpack": "static-1.3094",
  "ai-components-ui-library": "static-1.8686",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4749",
  "foundations-theming": "static-1.4314",
  "quartz-auth": "static-1.545",
  "ui-business-units-lib": "static-1.8942",
  "usage-tracker-session-replay": "static-1.4922",
  "foundations-theming-base": "static-1.3299",
  "HeadJS": "static-2.735",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3023",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4225",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7825",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3509",
  "persist-promise": "static-1.3610",
  "reporting-client-types": "static-1.2427",
  "foundations-components-legacy": "static-1.750",
  "hs-story-utils": "static-1.9331",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9734",
  "hubspotter-http": "static-1.4572",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7151",
  "crm-message-bus": "static-1.42703",
  "customer-data-filters-ui-msw-helpers": "static-1.21800",
  "customer-data-objects-ui-components": "static-1.12920",
  "customer-data-reference-ui-components": "static-1.13055",
  "customer-data-ui-utilities": "static-1.9726",
  "framework-builder-read-service-client": "static-1.3928",
  "framework-data-schema-quick-fetch": "static-1.6681",
  "framework-data-schema-resolvers": "static-1.6776",
  "inbound-db-properties-service-client": "static-1.3765",
  "multi-account-reference-resolvers": "static-1.875",
  "onboarding-tours": "static-1.16420",
  "reporting-datasets-permissions-lib": "static-1.13389",
  "ui-addon-teams": "static-1.21413",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68049",
  "customer-data-properties": "static-1.51196",
  "forms-ai-lib": "static-1.4163",
  "forms-utils-lib": "static-1.12393",
  "foundations-components-test-utils": "static-1.5208",
  "react-dnd-compat": "static-1.4519",
  "react-tinymce": "static-1.54955",
  "tinymce-config": "static-2.54081",
  "ui-gdpr-components": "static-1.10249",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3994",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1534",
  "ui-fonts": "static-1.617",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.819",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-head": "static-1.535",
  "quartz-i18n": "static-1.545",
  "quartz-routing": "static-1.300",
  "quartz-test": "static-1.545",
  "quartz-tracking": "static-1.249",
  "batch-promise": "static-1.1453",
  "external-options-client-types": "static-1.4078",
  "react-colorpicker": "static-2.10110",
  "copilot-toolkit": "static-1.10847",
  "data-quality-ui-library": "static-1.12613",
  "html-to-image": "static-1.52",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6365",
  "reporting-action-components": "static-1.40977",
  "reporting-insights-lib": "static-1.1416",
  "reporting-plugins": "static-1.10139",
  "ui-addon-draggable-compat": "static-2.4155",
  "ui-addon-opt": "static-4.8283",
  "ui-shepherd-react": "static-3.10048",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.25065",
  "hubspot-apollo-client": "static-1.4779",
  "chirp-fetch": "static-1.1782",
  "sales-templates-service-types-lib": "static-1.4087",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5685",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.3998",
  "nested-table": "static-1.127",
  "timezone-utils": "static-2.5145",
  "bender-build-tools": "static-1.3063",
  "chatspot-core": "static-1.20819",
  "bend-plugin-foundations-theming": "static-1.2797",
  "stylex": "static-1.30",
  "hubspotter-http-shared-msw-handlers": "static-1.9732",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3717",
  "crm-pipelines-api-client-types": "static-1.4062",
  "multi-currency-client-types": "static-1.3610",
  "getting-started-shared-tasks": "static-1.18213",
  "growth-data-modal": "static-1.5277",
  "growth-onboarding-confetti": "static-1.2972",
  "growth-onboarding-next-action-utils": "static-1.1620",
  "navigation-components": "static-1.17659",
  "onboarding-tours-client": "static-1.4634",
  "onboarding-tours-utils": "static-1.486",
  "ui-shepherd-tracker": "static-1.7429",
  "ui-universal-auth": "static-1.8838",
  "user-context": "static-1.5001",
  "cms-field-types": "static-1.4710",
  "content-icons-ui": "static-1.2203",
  "integrations-lib": "static-1.15793",
  "calling-global-api": "static-1.64106",
  "calling-internal-common": "static-1.31202",
  "calling-lifecycle-internal": "static-1.65488",
  "calling-lifecycle-messages": "static-1.57782",
  "commerce-products-lib": "static-1.9160",
  "crm-links": "static-1.6177",
  "customer-data-properties-shared-msw-handlers": "static-1.9061",
  "file-manager-components": "static-1.23305",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.40",
  "inbounddb-objects-service-types": "static-1.4143",
  "meetings-icalendar-utils-lib": "static-1.531",
  "object-builder-ui-client": "static-1.48402",
  "pipeline-validation-client-types": "static-1.3885",
  "property-value-citations": "static-1.1810",
  "pulse": "static-1.445",
  "smart-property-lib": "static-1.6453",
  "tiered-pricing": "static-1.1015",
  "ui-addon-iframeable": "static-1.8951",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19659",
  "tinymce-themes": "static-1.56051",
  "data-token-picker": "static-1.16230",
  "hub-http-contrib": "static-1.2944",
  "interframe": "static-3.4664",
  "tinymce-data": "static-1.40166",
  "tinymce-plugins": "static-1.57195",
  "ui-addon-sales-email": "static-1.5112",
  "magpie-lib": "static-1.5494",
  "magpie-types": "static-1.4954",
  "simple-logging-lib": "static-1.2952",
  "content-assistance-lib": "static-1.7606",
  "dashboard-lib": "static-1.81104",
  "ExportDialog": "static-6.10291",
  "hubspot-prosemirror": "static-1.17949",
  "hubspot-prosemirror-plugins": "static-1.17941",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8596",
  "campaign-roi-lib": "static-1.8652",
  "feedback-loader": "static-1.29111",
  "apollo-link-hub-http": "static-2.4552",
  "hubspot-apollo-cache": "static-1.238",
  "growth-monetization-service-types": "static-1.4403",
  "nav-client-types": "static-1.2259",
  "purchase-motions-api": "static-1.5688",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.74",
  "onboarding-data-sync-lib": "static-1.1794",
  "growth-onboarding-next-action-components": "static-1.1648",
  "user-context-client": "static-1.4513",
  "idb-keyval": "static-1.42",
  "nest": "static-1.123",
  "reactive-lib": "static-1.625",
  "unified-auth-core-lib": "static-1.633",
  "getting-started-shared-tasks-store": "static-1.17331",
  "integrations-error-boundary-lib": "static-1.13208",
  "integrations-tracking-lib": "static-1.5497",
  "native-integrations-shared-strings": "static-1.7687",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10275",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.352",
  "calling-error-reporting": "static-1.31208",
  "shared-worker-versioning": "static-1.10939",
  "calling-usage-tracker": "static-1.6442",
  "voice-sms-access-library": "static-1.605",
  "customer-data-tracking": "static-1.6785",
  "commerce-permissions": "static-1.666",
  "products-iframe-lib": "static-1.7647",
  "products-ui-components-shared-msw-handlers": "static-1.10116",
  "location-customization-utils-lib": "static-1.8925",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4054",
  "video-components-external": "static-1.10953",
  "video-data-lib": "static-1.34611",
  "directed-graph": "static-1.838",
  "event-emitter": "static-1.849",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.39",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9817",
  "fsm": "static-1.3635",
  "policy-lib": "static-1.6685",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9880",
  "navigation-messaging": "static-1.6986",
  "FileManagerLib": "static-1.38945",
  "NamespacedHubStyle": "static-2.8989",
  "FileManagerCore": "static-1.38804",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12252",
  "layout-dnd-utils": "static-1.11227",
  "react-codemirror": "static-1.10525",
  "ui-addon-emoji-picker": "static-1.9788",
  "ui-brand-identity-lib": "static-1.14797",
  "ui-addon-video-player": "static-1.8597",
  "ui-coaching-tips": "static-1.28261",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8445",
  "payment-link-components": "static-1.23247",
  "EmailSignatureEditor": "static-1.24156",
  "eligibility-engine-service-types": "static-1.3085",
  "InboxConnectUtils": "static-4.14533",
  "universal-page-editor-lib": "static-1.2908",
  "microsoft-drive-integration-lib": "static-1.25",
  "calling-orchestration-schema": "static-1.35382",
  "sales-views-client-types": "static-1.4164",
  "crm-record-cards-service-types": "static-1.3530",
  "content-media-composition-data-lib": "static-1.11910",
  "content-media-compositions": "static-2.15917",
  "media-bridge-lib": "static-1.18750",
  "trellis-story-utils": "static-1.4420",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5768",
  "FileManagerImages": "static-1.36456",
  "video-components": "static-1.12956",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4433",
  "video-embed": "static-1.35445",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68124",
  "layout-data-lib": "static-1.9552",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6483",
  "commerce-tours-lib": "static-1.5911",
  "growth-onboarding-reliability": "static-1.4987",
  "sales-checkout-service-client": "static-1.3569",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21499",
  "sales-email-signature-service-client": "static-1.3744",
  "social-insights-client-types": "static-1.21787",
  "outpost": "static-1.4095",
  "advanced-menus-core": "static-1.14975",
  "advanced-menus-lib": "static-1.11937",
  "ui-memberships-settings-lib": "static-1.33767",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14974",
  "simple-menus-lib": "static-1.16491"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34254",
  "client-types": "/client-types/static-1.457",
  "documents-lib": "/documents-lib/static-1.34259",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2030",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5495",
  "hs-test-utils": "/hs-test-utils/static-1.7912",
  "hub-http": "/hub-http/static-1.6120",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11355",
  "I18n": "/I18n/static-7.1603",
  "jasmine-immutable": "/jasmine-immutable/static-1.2918",
  "jasmine-runner": "/jasmine-runner/static-1.6369",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6870",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16557",
  "reporting-data": "/reporting-data/static-1.67033",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8966",
  "reporting-visualizations": "/reporting-visualizations/static-1.59109",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4670",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4972",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2395",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.770",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39365",
  "customer-data-objects": "/customer-data-objects/static-1.7560",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7985",
  "data-fetching-client": "/data-fetching-client/static-1.9576",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4430",
  "flux-actions": "/flux-actions/static-1.325",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85581",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4620",
  "foundations-components": "/foundations-components/static-1.7725",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11663",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7060",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3753",
  "property-translator": "/property-translator/static-1.5308",
  "quartz-config": "/quartz-config/static-1.648",
  "quartz-core": "/quartz-core/static-1.6089",
  "quick-fetch": "/quick-fetch/static-1.3836",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5268",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8068",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7990",
  "report-customization-components": "/report-customization-components/static-1.12840",
  "reporting-enablement": "/reporting-enablement/static-1.22513",
  "reporting-reports": "/reporting-reports/static-1.66711",
  "reporting-snowflake": "/reporting-snowflake/static-1.55651",
  "reporting-ui-components": "/reporting-ui-components/static-2.64304",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4545",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8838",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9090",
  "sanitize": "/sanitize/static-1.4374",
  "sanitize-text": "/sanitize-text/static-1.8046",
  "self-service-api": "/self-service-api/static-1.10146",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1651",
  "signup-constants": "/signup-constants/static-1.18662",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20672",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7941",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4670",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10892",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11048",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9445",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17844",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10884",
  "ui-images": "/ui-images/static-2.1130",
  "UIComponents": "/UIComponents/static-3.8302",
  "usage-tracker": "/usage-tracker/static-1.7236",
  "usage-tracker-container": "/usage-tracker-container/static-1.7226",
  "usage-tracker-core": "/usage-tracker-core/static-1.7086",
  "usage-tracker-public": "/usage-tracker-public/static-1.7047",
  "viral-links-lib": "/viral-links-lib/static-1.6943",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3325",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3147",
  "quartz-webpack": "/quartz-webpack/static-1.3094",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8686",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4749",
  "foundations-theming": "/foundations-theming/static-1.4314",
  "quartz-auth": "/quartz-auth/static-1.545",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8942",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4922",
  "foundations-theming-base": "/foundations-theming-base/static-1.3299",
  "HeadJS": "/HeadJS/static-2.735",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3023",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4225",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7825",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3509",
  "persist-promise": "/persist-promise/static-1.3610",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.750",
  "hs-story-utils": "/hs-story-utils/static-1.9331",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9734",
  "hubspotter-http": "/hubspotter-http/static-1.4572",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7151",
  "crm-message-bus": "/crm-message-bus/static-1.42703",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21800",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12920",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13055",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9726",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3928",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6681",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6776",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3765",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.875",
  "onboarding-tours": "/onboarding-tours/static-1.16420",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13389",
  "ui-addon-teams": "/ui-addon-teams/static-1.21413",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68049",
  "customer-data-properties": "/customer-data-properties/static-1.51196",
  "forms-ai-lib": "/forms-ai-lib/static-1.4163",
  "forms-utils-lib": "/forms-utils-lib/static-1.12393",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5208",
  "react-dnd-compat": "/react-dnd-compat/static-1.4519",
  "react-tinymce": "/react-tinymce/static-1.54955",
  "tinymce-config": "/tinymce-config/static-2.54081",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10249",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3994",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1534",
  "ui-fonts": "/ui-fonts/static-1.617",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.819",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-head": "/quartz-head/static-1.535",
  "quartz-i18n": "/quartz-i18n/static-1.545",
  "quartz-routing": "/quartz-routing/static-1.300",
  "quartz-test": "/quartz-test/static-1.545",
  "quartz-tracking": "/quartz-tracking/static-1.249",
  "batch-promise": "/batch-promise/static-1.1453",
  "external-options-client-types": "/external-options-client-types/static-1.4078",
  "react-colorpicker": "/react-colorpicker/static-2.10110",
  "copilot-toolkit": "/copilot-toolkit/static-1.10847",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12613",
  "html-to-image": "/html-to-image/static-1.52",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6365",
  "reporting-action-components": "/reporting-action-components/static-1.40977",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1416",
  "reporting-plugins": "/reporting-plugins/static-1.10139",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4155",
  "ui-addon-opt": "/ui-addon-opt/static-4.8283",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10048",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.25065",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4779",
  "chirp-fetch": "/chirp-fetch/static-1.1782",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4087",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5685",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.3998",
  "nested-table": "/nested-table/static-1.127",
  "timezone-utils": "/timezone-utils/static-2.5145",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "chatspot-core": "/chatspot-core/static-1.20819",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2797",
  "stylex": "/stylex/static-1.30",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9732",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3717",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4062",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3610",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18213",
  "growth-data-modal": "/growth-data-modal/static-1.5277",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2972",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1620",
  "navigation-components": "/navigation-components/static-1.17659",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4634",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.486",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7429",
  "ui-universal-auth": "/ui-universal-auth/static-1.8838",
  "user-context": "/user-context/static-1.5001",
  "cms-field-types": "/cms-field-types/static-1.4710",
  "content-icons-ui": "/content-icons-ui/static-1.2203",
  "integrations-lib": "/integrations-lib/static-1.15793",
  "calling-global-api": "/calling-global-api/static-1.64106",
  "calling-internal-common": "/calling-internal-common/static-1.31202",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65488",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57782",
  "commerce-products-lib": "/commerce-products-lib/static-1.9160",
  "crm-links": "/crm-links/static-1.6177",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9061",
  "file-manager-components": "/file-manager-components/static-1.23305",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.40",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4143",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.531",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48402",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3885",
  "property-value-citations": "/property-value-citations/static-1.1810",
  "pulse": "/pulse/static-1.445",
  "smart-property-lib": "/smart-property-lib/static-1.6453",
  "tiered-pricing": "/tiered-pricing/static-1.1015",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8951",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19659",
  "tinymce-themes": "/tinymce-themes/static-1.56051",
  "data-token-picker": "/data-token-picker/static-1.16230",
  "hub-http-contrib": "/hub-http-contrib/static-1.2944",
  "interframe": "/interframe/static-3.4664",
  "tinymce-data": "/tinymce-data/static-1.40166",
  "tinymce-plugins": "/tinymce-plugins/static-1.57195",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5112",
  "magpie-lib": "/magpie-lib/static-1.5494",
  "magpie-types": "/magpie-types/static-1.4954",
  "simple-logging-lib": "/simple-logging-lib/static-1.2952",
  "content-assistance-lib": "/content-assistance-lib/static-1.7606",
  "dashboard-lib": "/dashboard-lib/static-1.81104",
  "ExportDialog": "/ExportDialog/static-6.10291",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17949",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17941",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8596",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8652",
  "feedback-loader": "/feedback-loader/static-1.29111",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4552",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.238",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4403",
  "nav-client-types": "/nav-client-types/static-1.2259",
  "purchase-motions-api": "/purchase-motions-api/static-1.5688",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.74",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1794",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1648",
  "user-context-client": "/user-context-client/static-1.4513",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.123",
  "reactive-lib": "/reactive-lib/static-1.625",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.633",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17331",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13208",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5497",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7687",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10275",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.352",
  "calling-error-reporting": "/calling-error-reporting/static-1.31208",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10939",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6442",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.605",
  "customer-data-tracking": "/customer-data-tracking/static-1.6785",
  "commerce-permissions": "/commerce-permissions/static-1.666",
  "products-iframe-lib": "/products-iframe-lib/static-1.7647",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10116",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8925",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4054",
  "video-components-external": "/video-components-external/static-1.10953",
  "video-data-lib": "/video-data-lib/static-1.34611",
  "directed-graph": "/directed-graph/static-1.838",
  "event-emitter": "/event-emitter/static-1.849",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.39",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9817",
  "fsm": "/fsm/static-1.3635",
  "policy-lib": "/policy-lib/static-1.6685",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9880",
  "navigation-messaging": "/navigation-messaging/static-1.6986",
  "FileManagerLib": "/FileManagerLib/static-1.38945",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8989",
  "FileManagerCore": "/FileManagerCore/static-1.38804",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12252",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11227",
  "react-codemirror": "/react-codemirror/static-1.10525",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9788",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14797",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8597",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28261",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8445",
  "payment-link-components": "/payment-link-components/static-1.23247",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24156",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3085",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14533",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2908",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.25",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35382",
  "sales-views-client-types": "/sales-views-client-types/static-1.4164",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3530",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11910",
  "content-media-compositions": "/content-media-compositions/static-2.15917",
  "media-bridge-lib": "/media-bridge-lib/static-1.18750",
  "trellis-story-utils": "/trellis-story-utils/static-1.4420",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5768",
  "FileManagerImages": "/FileManagerImages/static-1.36456",
  "video-components": "/video-components/static-1.12956",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4433",
  "video-embed": "/video-embed/static-1.35445",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68124",
  "layout-data-lib": "/layout-data-lib/static-1.9552",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6483",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5911",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4987",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21499",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3744",
  "social-insights-client-types": "/social-insights-client-types/static-1.21787",
  "outpost": "/outpost/static-1.4095",
  "advanced-menus-core": "/advanced-menus-core/static-1.14975",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11937",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33767",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14974",
  "simple-menus-lib": "/simple-menus-lib/static-1.16491"
}
};
